import React from "react";
import { Link } from "react-router-dom";
import { Loader } from "Components/General/Loader";
import { observer } from "mobx-react";
import { projectsDataStore } from "Stores";
import { objectsAndDataStore } from "../Stores/ObjectsAndDataStore";
import { WithTranslation, withTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { WithRouterProps } from "Components/General/WithRouter";

interface BreadcrumpNavigationProps extends WithTranslation, WithRouterProps {
  activeSubTab?: string;
}

export const BreadcrumpNavigation = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<BreadcrumpNavigationProps> {
      handleClick = (valueTableId, valueTableDataId, activeSubTab?) => () => {
        let link = `/project/${projectsDataStore.projectId}/values/${valueTableId}/sub-object/${valueTableDataId}`;
        if (this.props.activeSubTab) {
          link += "/" + activeSubTab;
        }
        this.props.navigate(link);
      };

      render() {
        const { objectData } = objectsAndDataStore;

        if (!objectData) return <Loader />;
        let path = objectData.path;
        const entries = [];
        let first = true;
        let activeTab = this.props.activeSubTab;
        if (activeTab === "__attachments") {
          activeTab = this.props.t("Attachments");
        }

        while (path) {
          entries.push(
            <Link
              key={entries.length}
              className={!first ? "ant-breadcrumb-link" : "active-crumb"}
              style={!first ? { cursor: "pointer" } : null}
              to={`/project/${projectsDataStore.projectId}/values/${path.valueTableId}/sub-object/${path.valueTableDataId}`}
            >
              {path.pathName + (first ? " : " + activeTab : "")} {!first ? " > " : ""}
            </Link>
          );
          if (path.parent) {
            entries.push(
              <Link
                key={entries.length}
                className="ant-breadcrumb-link"
                to={`/project/${projectsDataStore.projectId}/values/${path.parent.valueTableId}/sub-object/${path.parent.valueTableDataId}/${path.valueTableName}`}
              >
                {path.valueTableName} {" > "}
              </Link>
            );
          } else {
            entries.push(
              <Link
                key={entries.length}
                className="ant-breadcrumb-link"
                to={`/project/${projectsDataStore.projectId}/values/${path.valueTableId}/search-results?${
                  objectsAndDataStore.lastSearchValue || "*"
                }`}
              >
                {path.valueTableName} {" > "}
              </Link>
            );
          }

          path = path.parent;
          first = false;
        }
        return <div>{entries.reverse()}</div>;
      }
    }
  )
);
